const API_BASE = '/api';

export type AppConfig = {
  MEETING_REDIRECT_MS: number;
};

export async function fetchAppConfig(): Promise<AppConfig | null> {
  const res = await fetch(`${API_BASE}/config`, {
    method: 'GET',
    headers: { 'X-Requested-With': 'ZoneLayerTeams' },
    credentials: 'omit',
    cache: 'no-store',
  });
  if (!res.ok) return null;
  const data = await res.json();
  const ms = Number(data.MEETING_REDIRECT_MS);
  if (!Number.isFinite(ms) || ms <= 0) return null;
  return { MEETING_REDIRECT_MS: ms };
}

export async function fetchMeetingUrl(name: string, email?: string): Promise<string | null> {
  const url = new URL(`${API_BASE}/meeting-url`, window.location.origin);
  url.searchParams.set('name', name);
  if (email?.trim()) url.searchParams.set('email', email.trim().toLowerCase());
  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: { 'X-Requested-With': 'ZoneLayerTeams' },
    credentials: 'omit',
    cache: 'no-store',
  });
  if (!res.ok) return null;
  const data = await res.json();
  return typeof data.meetingUrl === 'string' ? data.meetingUrl : null;
}

export function getMeetingRedirectMs(config: AppConfig | null | undefined): number {
  const ms = config?.MEETING_REDIRECT_MS;
  return ms && ms > 0 ? ms : 6000;
}
